export const resolveApiBase = () => {
    const envBase = import.meta.env.VITE_API_BASE_URL;
    const localProxyBase = "/api";

    if (typeof window !== "undefined") {
        const host = window.location.hostname;
        const port = window.location.port;
        const isLocalHost = host === "localhost" || host === "127.0.0.1";

        if (isLocalHost && (port === "" || port === "80" || port === "443")) {
            return localProxyBase;
        }
    }

    if (envBase) {
        return envBase.replace(/\/$/, "");
    }

    return "/api";
};
